export default __webpack_public_path__ + "static/img/top-space-sm.f64d0ba.jpg";